import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

import iconQuestionMarkCircleFilled from "../../img/icons/question-mark-circle-filled.svg";
import { dynamicPlaceComponent } from "../utils/react";

/**
 * Activate tooltips. HTML should be in the format:
 *
 *     <span data-tooltip="This is the content of my fancy new tooltip."></span>
 */
export const initTooltips = async (lazy = true) => {
    let index = 0;
    dynamicPlaceComponent(
        "[data-tooltip]:not([data-tooltip-rendered])",
        async (elem) => {
            const text = elem.dataset.tooltip;
            if (!text) {
                return null;
            }
            const tooltipId = elem.dataset.tooltipId;
            const srText = elem.dataset.tooltipSr || t`More information`;
            elem.dataset.tooltipId = tooltipId;
            if (elem.dataset.tooltipRendered === "true") {
                return null;
            }
            elem.setAttribute("data-tooltip-rendered", "true");
            const ReactTooltip = (await import("react-tooltip")).default;
            const tipID = `tooltip-${index++}`;
            return (
                <>
                    <span
                        className="tooltip"
                        data-tip={true}
                        data-for={tipID}
                        tabIndex={0}
                        aria-describedby={tipID}
                    >
                        <SVG
                            className="tooltip__handle"
                            src={iconQuestionMarkCircleFilled}
                            aria-hidden="true"
                        />
                        <span className="ada-screenreader-only">{srText}</span>
                    </span>
                    <ReactTooltip
                        id={tipID}
                        uuid={tipID}
                        className="tooltip__content"
                        event={"mouseover focus"}
                        eventOff="scroll mousewheel mouseleave mouseout blur"
                        isCapture={true}
                        role="tooltip"
                        html={true}
                        overridePosition={(
                            { left, top },
                            _currentEvent,
                            _currentTarget,
                            node,
                        ) => {
                            const document = getDocument();
                            if (!document) {
                                return { top, left };
                            }
                            const d = document.documentElement;
                            left = Math.min(
                                d.clientWidth - node!.clientWidth,
                                left,
                            );
                            top = Math.min(
                                d.clientHeight - node!.clientHeight,
                                top,
                            );
                            left = Math.max(0, left);
                            top = Math.max(0, top);
                            return { top, left };
                        }}
                    >
                        {text}
                    </ReactTooltip>
                </>
            );
        },
        lazy,
    );
};
